import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { workItems } from '../data/mock';

const Work = () => {
  // Group items into rows of varying sizes for editorial balance
  const createRows = () => {
    const rows = [];
    let index = 0;
    
    // Row pattern: 3, 2, 3, 2 for visual variety
    const rowSizes = [3, 2, 3, 2];
    let rowIndex = 0;
    
    while (index < workItems.length) {
      const rowSize = rowSizes[rowIndex % rowSizes.length];
      const row = workItems.slice(index, index + rowSize);
      if (row.length > 0) {
        rows.push(row);
      }
      index += rowSize;
      rowIndex++;
    }
    
    return rows;
  };

  const rows = createRows();

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      
      {/* Work Gallery - Editorial Grid */}
      <section className="pt-24 pb-8">
        <div className="w-full">
          {/* Stacked Rows with Small Gaps */}
          <div className="flex flex-col gap-2">
            {rows.map((row, rowIndex) => (
              <div key={rowIndex} className="flex gap-2 w-full h-[32vh]">
                {row.map((item) => (
                  <a
                    key={item.id}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group relative flex-1 overflow-hidden cursor-pointer"
                  >
                    <img 
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110 group-hover:opacity-70"
                    />
                    {/* Minimal Overlay on Hover */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                        <h3 className="text-white text-sm md:text-base font-light tracking-wider lowercase">
                          {item.title}
                        </h3>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Work;
